var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg96(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    width: "48px",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n        .st4{fill:#FFFFFF;}\r\n        .st18{stroke:#000000;}\r\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_14"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "currentColor",
    className: "st18",
    x1: 10.78,
    y1: 7.59,
    x2: 10.78,
    y2: 42.49
  }), /*#__PURE__*/React.createElement("line", {
    fill: "currentColor",
    className: "st18",
    x1: 13.18,
    y1: 9.7,
    x2: 13.18,
    y2: 43.71
  }), /*#__PURE__*/React.createElement("line", {
    fill: "currentColor",
    className: "st18",
    x1: 16.08,
    y1: 9.09,
    x2: 16.08,
    y2: 44.56
  }), /*#__PURE__*/React.createElement("line", {
    fill: "currentColor",
    className: "st18",
    x1: 18.99,
    y1: 10.78,
    x2: 18.99,
    y2: 46.25
  }), /*#__PURE__*/React.createElement("line", {
    fill: "currentColor",
    className: "st18",
    x1: 21.89,
    y1: 10.78,
    x2: 21.89,
    y2: 46.25
  }), /*#__PURE__*/React.createElement("line", {
    fill: "currentColor",
    className: "st18",
    x1: 24.8,
    y1: 10.78,
    x2: 24.8,
    y2: 46.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "st18",
    x1: 27.7,
    y1: 10.78,
    x2: 27.7,
    y2: 46.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "st18",
    x1: 31.02,
    y1: 8.93,
    x2: 31.02,
    y2: 44.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st18",
    x1: 33.93,
    y1: 9.09,
    x2: 33.93,
    y2: 44.56
  }), /*#__PURE__*/React.createElement("line", {
    fill: "currentColor",
    className: "st18",
    x1: 36.83,
    y1: 7.4,
    x2: 36.83,
    y2: 42.86
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.58,40.72c0,0,13.75,9.99,27.89,0c0,0,3.14,5.12-13.62,6.15C23.85,46.87,9.32,47.25,9.58,40.72z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "currentColor",
    cx: 24,
    cy: 6.17,
    rx: 15.56,
    ry: 5.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "currentColor",
    cx: 24.18,
    cy: 6.35,
    rx: 6.89,
    ry: 1.66
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg96);
export default __webpack_public_path__ + "static/media/96.fb9ee668e21cf45172670040a4a54692.svg";
export { ForwardRef as ReactComponent };